import { FSA } from 'flux-standard-action';
import { ConfigurationModel } from 'franke-trough-dependencies';
import { RequestApiError } from 'loopback-react-request';

/**
 * Action types
 */
export enum ConfigurationValidationTypes {
  clear = '@Configuration-Validation/clear',
  validate = '@Configuration-Validation/validate',
}

export interface ValidateConfiguration {
  clear(): FSA<ConfigurationValidationTypes.clear, undefined>;
  validate(configuration: ConfigurationModel, error?: RequestApiError): FSA<ConfigurationValidationTypes.validate, {configuration: ConfigurationModel}>;
}

export interface ValidateConfigurationPayload {
  configuration: ConfigurationModel;
  error?: RequestApiError;
}

/** Action that pushes the whole configuration data to check the validation of each object
 * 
 * @param configuration
 * @return FSA<{configuration: ConfigurationModel}>
 */
const validate = (configuration: ConfigurationModel, error?: RequestApiError): FSA<ConfigurationValidationTypes.validate, ValidateConfigurationPayload> => ({
  type: ConfigurationValidationTypes.validate,
  payload: {
    configuration,
    error,
  },
});

/**
 * Action that clears the validation state
 * 
 * @returns FSA<undefined>
 */
const clear = (): FSA<ConfigurationValidationTypes.clear, undefined> => ({
  type: ConfigurationValidationTypes.clear
});

export const validateConfiguration = {
  clear,
  validate,
};